import {action, makeAutoObservable} from "mobx";

export class DeleteDialogStore {
    /** ダイアログの開閉状態 */
    isOpen = false;

    /** ダイアログの見出し（タイトル部分） */
    title = "";

    /** ダイアログ本文として表示したいメッセージ全文 */
    message = "";

    /** 「削除」ボタン押下時に実行するコールバック
     *  戻り値は void でも Promise<void> でもOK とする */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onDelete: () => void | Promise<void> = () => {};

    constructor() {
        makeAutoObservable(this);
    }

    /**
     * ダイアログを開く
     * @param title   ダイアログの上部に表示する見出し
     * @param message ダイアログ本文全体。
     * @param onDelete 削除ボタン押下時に実行する関数（同期でも async でも良い）
     */
    @action
    public open(title: string, message: string, onDelete: () => void | Promise<void>) {
        this.title = title;
        this.message = message;
        this.onDelete = onDelete;
        this.isOpen = true;
    }

    /** ダイアログを閉じる */
    @action.bound
    public close() {
        this.isOpen = false;
    }

    /**
     * モーダルの「削除」ボタンが押されたときに呼ばれる
     * → onDelete() の実行結果を待ってから close() する
     */
    @action.bound
    public handleDelete = async () => {
        try {
            // onDelete が同期関数ならすぐ終わるし、Promise を返すなら await してくれる
            const result = this.onDelete();
            if (result instanceof Promise) {
                await result;
            }
        } catch (e) {
            console.error("DeleteDialogStore.handleDelete 内でエラー", e);
        }
        this.close();
    };
}

// シングルトンインスタンスをエクスポート
export const deleteDialogStore = new DeleteDialogStore();
